import React from "react";
import cn from "classnames";

import DropdownItem from '../../DropdownItem';
import { dropdownItems } from '../../Content';

const SolutionsDropdown = ({ theme, dropdown, navResponsive }) => (
  <div>
    <div className="grid grid-cols-2 w-max" data-first-dropdown-section>
      <div className="pt-10 pb-12 px-14">
        <h4 className="text-overtitle-sm text-gradient inline-block mb-6">{dropdownItems[dropdown].industries.title}</h4>
        <ul className="grid grid-cols-none gap-y-6">
          {dropdownItems[dropdown].industries.content.map(item => (
            <DropdownItem
              key={item.title}
              href={item.href}
              icon={item.icon}
              title={item.title}
              text={item.text}
              colors={theme.dropdown.items}
              itemType={item.type}
              navResponsive={navResponsive}
            />
          ))}
        </ul>
      </div>
      <div className={cn(theme.dropdown.backgroundSolutions, 'pt-10 pb-12 px-14')}>
        <h4 className="text-overtitle-sm text-gradient inline-block mb-6">{dropdownItems[dropdown].useCases.title}</h4>
        <ul className="grid grid-cols-none gap-y-6">
          {dropdownItems[dropdown].useCases.content.map(item => (
            <DropdownItem
              key={item.title}
              href={item.href}
              icon={item.icon}
              title={item.title}
              text={item.text}
              colors={theme.dropdown.items}
              itemType={item.type}
              navResponsive={navResponsive}
            />
          ))}
        </ul>
      </div>
    </div>
  </div>
)

SolutionsDropdown.defaultProps = {
  dropdown: 'solutions',
  navResponsive: false
};

export default SolutionsDropdown
